/**
 * Ogni quanto gli avvisi del Layout (AlertNotifier, RitardiNotifier,
 * AttesaNotifier) rileggono il server: un minuto. Lo stesso orologio, col
 * loro predefinito, lo usano le altre letture periodiche del guscio: i
 * numeri accanto alle voci (hooks/useContatori.js, un minuto) e «Controlli»
 * in alto (components/guscio/BarraInAlto.jsx, cinque minuti).
 *
 * Le prove dei percorsi (scenario 15, caso 10h) lo accorciano con
 * window.__rimedichubTempiAvvisi = { periodo }, messo prima del caricamento,
 * come i tempi della versione (window.__rimedichubTempiVersione) e del tablet
 * (window.__rimedichubTempiTablet): sono queste letture che, svegliate
 * insieme al controllo della versione, tenevano ferma la ricarica di una
 * scheda nascosta da tempo (revisione del 2/10, utils/versioneInLinea.js), e
 * aspettare un minuto vero fra due letture non e' una prova, e' una pausa.
 * Mai sotto i 100 ms: un valore sbagliato non deve diventare un giro
 * continuo di richieste.
 */
export function periodoAvvisi(predefinito) {
    const v = Number(typeof window !== 'undefined' && window.__rimedichubTempiAvvisi
        ? window.__rimedichubTempiAvvisi.periodo : NaN);
    return Number.isFinite(v) && v >= 100 ? v : predefinito;
}
